import { render, staticRenderFns } from "./SrRadioButton.vue?vue&type=template&id=218829fc&scoped=true"
import script from "./SrRadioButton.vue?vue&type=script&lang=js"
export * from "./SrRadioButton.vue?vue&type=script&lang=js"
import style0 from "./SrRadioButton.vue?vue&type=style&index=0&id=218829fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218829fc",
  null
  
)

export default component.exports